import { AxiosRequestConfig } from 'axios';
import request from 'src/services/request';
import { ILearning } from '@src/features/feed/models/LearningModel';

export const getMagazinesPath = qs => '/board/magazines' + qs;
export const getLearningPath = qs => '/board/learning' + qs;
export const getArticlesPath = (qs?: string) => `/articles${qs ? qs : ''}`;
export const getLearningTopPicksPath = qs => getLearningPath(qs) + '&top_pick_from_sainoo=true';

export function getLearning(id: number, config?: AxiosRequestConfig) {
  return request.get<void, ILearning>(`/learning/${id}`, config);
}
